import { useEffect, useState } from "react";
import { Building2, Megaphone, Radar, Eye, Users, MousePointerClick } from "lucide-react";
import api from "@/lib/api";
import KpiCard from "@/components/KpiCard";
import LiveFeed from "@/components/LiveFeed";
import GeoMap from "@/components/GeoMap";
import { Skeleton } from "@/components/ui/skeleton";

export default function AdminDashboard() {
  const [data, setData] = useState(null);

  const load = () => api.get("/admin/dashboard").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const id = setInterval(load, 30000);
    return () => clearInterval(id);
  }, []);

  if (!data) return <div className="space-y-5">{[...Array(3)].map((_, i) => <Skeleton key={i} className="h-36 bg-white/5" />)}</div>;

  const t = data.totals;
  const campaigns = data.campaigns || [];
  const geoWithCampaign = data.geofences.map((g) => ({
    ...g,
    campaign_name: campaigns.find((c) => c.id === g.campaign_id)?.name,
  }));

  return (
    <div className="space-y-6" data-testid="admin-dashboard">
      <div>
        <p className="section-label">Command Centre</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold text-white tracking-tight mt-1">Platform Overview</h2>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4">
        <KpiCard title="Clients" value={data.total_clients} icon={Building2} testid="admin-kpi-clients" />
        <KpiCard title="Active Campaigns" value={data.active_campaigns} icon={Megaphone} testid="admin-kpi-campaigns" />
        <KpiCard title="Active Geofences" value={data.active_geofences} icon={Radar} testid="admin-kpi-geofences" />
        <KpiCard title="Impressions" value={t.impressions} icon={Eye} testid="admin-kpi-impressions" />
        <KpiCard title="Reach" value={t.reach} icon={Users} testid="admin-kpi-reach" />
        <KpiCard title="Engagements" value={t.engagements} icon={MousePointerClick} testid="admin-kpi-engagements" />
      </div>

      <div className="grid lg:grid-cols-[1.6fr_1fr] gap-6">
        <GeoMap geofences={geoWithCampaign} height="520px" testid="admin-map" />
        <LiveFeed initial={data.recent_events} testid="admin-live-feed" />
      </div>

      <div className="card-surface p-5" data-testid="admin-clients-summary">
        <h3 className="font-display font-semibold text-sm tracking-wide text-white mb-4">CLIENT ACCOUNTS</h3>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[10px] tracking-widest text-slate-500 uppercase border-b border-white/5">
                <th className="pb-3 pr-4">Client</th><th className="pb-3 pr-4">Code</th>
                <th className="pb-3 pr-4">Industry</th><th className="pb-3">Status</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {data.clients.map((c) => (
                <tr key={c.id} className="text-slate-300">
                  <td className="py-3 pr-4 font-semibold text-white">{c.company}</td>
                  <td className="py-3 pr-4 font-mono text-xs">{c.client_code}</td>
                  <td className="py-3 pr-4 text-xs">{c.industry}</td>
                  <td className="py-3">
                    <span className={`text-[10px] font-bold tracking-widest px-2 py-1 rounded border ${c.status === "ACTIVE" ? "bg-emerald-500/10 text-emerald-400 border-emerald-500/30" : "bg-slate-500/10 text-slate-400 border-slate-500/30"}`}>
                      {c.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
